import { getEmptyGuid } from '../../components/Utils';
import { validationRules } from '../validationRules';
import { ValidateResponse } from '../Validator';
import { TimeEntry, TimeUserFeatures, UserRegistrationPeriod, WorkProjectType, WorkType } from '../../api/generated/data-contracts';

interface TimeEntriesMustHaveWorkTypeProps {
    timeEntries: TimeEntry[];
    timeRows: UserRegistrationPeriod[];
    config: TimeUserFeatures;
    allowedWorkTypes: WorkType[];
    projectTypes: WorkProjectType[];
}

export const TimeEntriesMustHaveWorkType = (props: TimeEntriesMustHaveWorkTypeProps): ValidateResponse => {
    const isNotDefaultAndHasNoWorkType = (timeEntry: TimeEntry) => {
        return timeEntry.assignment.timeTask?.isDefault === false && timeEntry.assignment.workType?.id === getEmptyGuid();
    };
    const isAvailableWorktype = (timeRow: UserRegistrationPeriod) => {
        if (timeRow === undefined) {
            return true;
        }
        if (timeRow.timeEntries?.length <= 0 || timeRow.timeEntries.some(_ => _.assignment.timeTask?.isDefault === true)) {
            return true;
        }
        const userWorkTypes = [...props.allowedWorkTypes];
        if (userWorkTypes.length === 0) {
            return true;
        }
        const projectWorkTypes = props.projectTypes.find(_ => _.id === timeRow.projectWorkType?.id)?.allowedWorkTypes || [];
        if (projectWorkTypes.length === 0) {
            return true;
        } else if (projectWorkTypes.length === 1 && projectWorkTypes[0].id === getEmptyGuid()) {
            return true;
        }
        const userWorkTypesInProject = userWorkTypes.filter(uw => projectWorkTypes.some(pw => pw.id === uw.id));
        const projectWorkTypesInUser = projectWorkTypes.filter(uw => userWorkTypes.some(pw => pw.id === uw.id));
        const avaiableWorkWtype = [...projectWorkTypesInUser, ...userWorkTypesInProject].filter((v, i, a) => a.findIndex(t => t.id === v.id) === i);

        const rowWorkType = timeRow.workType;
        const workTypeAllowed = avaiableWorkWtype?.find(wt => wt.id === rowWorkType?.id);
        if (!workTypeAllowed) {
            return false;
        } else {
            return true;
        }
    };

    const anyTimeEntriesWithoutWorktType = props.timeEntries.filter(_ => _.hours !== 0).some(_ => !_.assignment.workType || isNotDefaultAndHasNoWorkType(_));
    const anyTimeEntriesWithUnavailableWorktType = props.timeRows
        .filter(_ => _.timeEntries.some(_ => _.hours !== 0) === true)
        .some(_ => !isAvailableWorktype(_));
    const tests = props.timeRows.filter(_ => _.timeEntries.some(_ => _.hours !== 0) === true).find(_ => !isAvailableWorktype(_));
    isAvailableWorktype(tests);
    const response: ValidateResponse = {
        reason: anyTimeEntriesWithoutWorktType || anyTimeEntriesWithUnavailableWorktType ? 'Please select work type before submitting your timesheet' : null,
        valid: !(anyTimeEntriesWithoutWorktType || anyTimeEntriesWithUnavailableWorktType),
        // name: validationRules.TimeEntriesMustHaveWorkType,
        name: validationRules.timeEntriesMustHaveWorkType,
        rejected: anyTimeEntriesWithoutWorktType || anyTimeEntriesWithUnavailableWorktType,
    };

    return response;
};
